export const qrSize = 256;
export const minResolutionSize = 150;
export const mobileWidth = 1000;
